import React from 'react';
import { Link } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';

export default function AdminHeader({ email, role, onRefreshRole }) {
  const { t } = useLanguage();
  return (
    <header className="flex items-center gap-3 border-b border-slate-200 bg-white px-4 py-3">
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-slate-900">{t('admin.shell.title')}</p>
        <p className="truncate text-xs text-slate-500">
          {email || '—'} · {role || t('admin.shell.legacyRole')}
        </p>
      </div>
      {onRefreshRole ? (
        <button
          type="button"
          onClick={onRefreshRole}
          className="inline-flex items-center gap-1 rounded-lg border border-slate-200 px-2 py-1 text-xs text-slate-600 hover:bg-slate-50"
          title={t('admin.shell.refreshRole')}
        >
          <RefreshCw className="h-3.5 w-3.5" />
          {t('admin.shell.refreshRole')}
        </button>
      ) : null}
      <Link to="/" className="text-xs font-medium text-indigo-600 hover:underline">
        {t('admin.shell.backToApp')}
      </Link>
    </header>
  );
}
